// extracted by mini-css-extract-plugin
module.exports = {"root":"blog-search_root__o62ON","input":"blog-search_input__Zg9NU","button":"blog-search_button__BQh9X","icon":"blog-search_icon__vY2iD"};